import { pipe } from '#/providers/creative/pipe.js';
import { filter } from 'rxjs';

export function fetchExtrasFactory(dependencies) {
  return function fetchExtras(creative) {
    const subRequests = [];
    for (const widgetKey in creative.i18nEntities.widgets) {
      const widget = creative.i18nEntities.widgets[widgetKey];
      if (widget.linkType?.startsWith('megogo://purchase/')) {
        subRequests.push(getPurchaseOptions(widget, dependencies));
      }
    }

    if (!subRequests.length) {
      return Promise.resolve(creative);
    }

    return Promise.all(subRequests).then((injectors) =>
      pipe(...injectors)(creative),
    );
  };
}

function getPurchaseOptions(widget, dependencies) {
  const { hostGateway } = dependencies;
  const {
    promise,
    resolve,
    reject
  } = Promise.withResolvers();
  const videoId = widget.linkType.replace('megogo://purchase/', '');
  hostGateway.sendEvent('interactive:purchase', {
    videoId,
    stage: 'options'
  });

  const subscription = hostGateway.message$
    .pipe(
      filter((message) => message.cmd === 'purchase-options' && message.payload.videoId === videoId)
    )
    .subscribe((message) => {
      subscription.unsubscribe();
      if (message.payload.error) {
        reject(message.payload);
      }
      resolve((creative) => {
        creative.i18nEntities.widgets[widget.id].purchaseOptions = {
          available: message.payload.available,
          options: message.payload.options,
          extras: message.payload.extras
        };
        return creative;
      });
    });

  return promise;
}
